import { type RefObject } from 'react';

export enum PortalArea {
    Page = 'page',
    Profile = 'profile',
    Toast = 'toast',
    Transition = 'transition',
}

export type PortalAreaRef = RefObject<HTMLElement> | null;
export type PortalAreaRefPair = [PortalArea, PortalAreaRef];

export interface PortalAreaScope {
    [PortalArea.Page]: PortalAreaRef;
    [PortalArea.Profile]: PortalAreaRef;
    [PortalArea.Toast]: PortalAreaRef;
    [PortalArea.Transition]: PortalAreaRef;
}

export interface PortalContextDescriptor {
    area: PortalAreaScope;
    setPortalArea(data: PortalAreaRefPair): void;
}

export type PortalAreaUpdater = PortalContextDescriptor['setPortalArea'];
